import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Field } from 'redux-form';

import {
  renderCurrencyField,
  renderCLCurrencyField,
} from '../../../../../utils/redux-form-helper';
import messages from './messages';

export const PetFeesAndRent = ({
  intl,
  isEditable,
  handleAutoFilledFieldChange,
  autoFilledLeaseChargeFields,
}: Object) => {
  const { automatedLeaseChargesP1 } = useFlags();
  const getBackgroundColor = (fieldName) =>
    autoFilledLeaseChargeFields[fieldName] ? 'warning.lighter' : undefined;
  return (
    <Row>
      <Col xs={12} md={8} className="padtop20">
        <h2>
          <i className="et-pet text-blue padright10" />
          {intl.formatMessage(messages.petFeesAndRentLabel)}
        </h2>
        <Col xs={12}>
          <form>
            <Col xs={12} sm={4}>
              <label>Pet Deposit </label>
              <div className="form-group">
                <Field
                  name="petDeposit"
                  component={
                    automatedLeaseChargesP1
                      ? renderCLCurrencyField
                      : renderCurrencyField
                  }
                  step="0.01"
                  disabled={!isEditable}
                  onChange={(_, value) => {
                    if (!automatedLeaseChargesP1) {
                      return;
                    }
                    handleAutoFilledFieldChange('petDeposit', value);
                  }}
                  InputProps={
                    automatedLeaseChargesP1 && {
                      sx: {
                        backgroundColor: getBackgroundColor('petDeposit'),
                      },
                    }
                  }
                />
              </div>
            </Col>
            <Col xs={12} sm={4}>
              <label>Monthly Pet Rent</label>
              <div className="form-group">
                <Field
                  name="monthlyPetRent"
                  component={
                    automatedLeaseChargesP1
                      ? renderCLCurrencyField
                      : renderCurrencyField
                  }
                  step="0.01"
                  disabled={!isEditable}
                  onChange={(_, value) => {
                    if (!automatedLeaseChargesP1) {
                      return;
                    }
                    handleAutoFilledFieldChange('monthlyPetRent', value);
                  }}
                  InputProps={
                    automatedLeaseChargesP1 && {
                      sx: {
                        backgroundColor: getBackgroundColor('monthlyPetRent'),
                      },
                    }
                  }
                />
              </div>
            </Col>
            <Col xs={12} sm={4}>
              <label>Pet Fee</label>
              <div className="form-group">
                <Field
                  name="petFee"
                  component={
                    automatedLeaseChargesP1
                      ? renderCLCurrencyField
                      : renderCurrencyField
                  }
                  step="0.01"
                  disabled={!isEditable}
                  onChange={(_, value) => {
                    if (!automatedLeaseChargesP1) {
                      return;
                    }
                    handleAutoFilledFieldChange('petFee', value);
                  }}
                  InputProps={
                    automatedLeaseChargesP1 && {
                      sx: {
                        backgroundColor: getBackgroundColor('petFee'),
                      },
                    }
                  }
                />
              </div>
            </Col>
          </form>
        </Col>
      </Col>
      <Col
        xs={12}
        md={4}
        className="col-xs-12 col-md-4 divider-vertical padtop20 padbottom10"
      >
        <h2>
          <i className="et-money text-blue padright10" />
          Short Term Fee
        </h2>
        <div className="col-xs-12">
          <form>
            <Col xs={12} sm={12}>
              <label>{intl.formatMessage(messages.feeAmount)}</label>
              <div className="form-group">
                <Field
                  name="shortTermFee"
                  component={
                    automatedLeaseChargesP1
                      ? renderCLCurrencyField
                      : renderCurrencyField
                  }
                  step="0.01"
                  disabled={!isEditable}
                  onChange={(_, value) => {
                    if (!automatedLeaseChargesP1) {
                      return;
                    }
                    handleAutoFilledFieldChange('shortTermFee', value);
                  }}
                  InputProps={
                    automatedLeaseChargesP1 && {
                      sx: {
                        backgroundColor: getBackgroundColor('shortTermFee'),
                      },
                    }
                  }
                />
              </div>
            </Col>
          </form>
        </div>
      </Col>
    </Row>
  );
};

export default PetFeesAndRent;
